import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import { jsx } from 'react/jsx-runtime';
import { TabPanel as TabPanel$1 } from '@ariakit/react';
import { forwardRef } from 'react';
import { useTabs } from './use-tabs.js';
var TabPanel = /*#__PURE__*/forwardRef(function TabPanel(props, ref) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  var tab = useTabs();

  if (!tab) {
    throw new Error('TabPanel must be wrapped in a Tabs component');
  }

  return jsx(TabPanel$1, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    store: tab,
    children: children
  }));
});
export { TabPanel };